export enum EZoneGeo {
	METROPOLE = 1,
	DROM = 2,
}